import { formatAddress } from "./address";
import { convertCountryCodeToCountryName } from "./country";
export const ORG_PAGE_DEFAULT_SOCIAL_PLATFORMS = ["Facebook", "X", "YouTube"];
export const formatOrgPageFooterAddress = ({ address, city, region, postalCode }) => formatAddress({ address, city, region, postalCode });
export const buildOrgPageFooterAddressMapsUrl = (footerAddress) => {
    const query = formatAddress({
        ...footerAddress,
        country: convertCountryCodeToCountryName(footerAddress.countryCode) ?? footerAddress.countryCode,
    });
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};
export const ORG_PAGE_FOOTER_BLOCK_MAX_COUNT = 50;
export const ORG_PAGE_FOOTER_BLOCK_TITLE_MAX_LENGTH = 100;
export const ORG_PAGE_FOOTER_BLOCK_CONTENT_MAX_LENGTH = 500;
